import React, { Component } from 'react';
import StepZilla from 'react-stepzilla';

import { connect } from "react-redux"

import ProductSelectionStep from 'components/SalesWizard/Steps/ProductSelectionStep';
import NegotiationStep from 'components/SalesWizard/Steps/NegotiationStep';
import SpotTreeSelectionStep from 'components/SalesWizard/Steps/SpotTreeSelectionStep';
import SummaryStep from 'components/SalesWizard/Steps/SummaryStep';
import Loader from "components/elements/loader/Loader";

import { fetchContractTypeSeller } from 'reducers/seller/sellerActions';
import { cleanSaleOrder } from 'reducers/saleorder/saleorderActions';
import ContractTypeModal from 'components/ContractTypeModal/ContractTypeModal';

class SalesWizard extends Component {

    componentWillMount() {
        this.props.cleanSaleOrder();

        this.state = {
            loading: true,
            showContractModal: false
        }

        let promise = new Promise((resolve, reject) => {
            this.props.fetchContractTypeSeller(resolve, reject);
        });

        promise.then((response) => {
            if (response.value != null) {
                this.setState({ loading: false });
            } else {
                this.setState({ showContractModal: true });
            }
        });
    }

    constructor(props) {
        super(props);
    }

    handleStepChange(step) {
        switch (step) {
            case 1:
                {

                }
                break;

            case 2: {

            }
                break;
        }
    }

    render() {
        const steps = [
            { name: "Seleccionar", component: <ProductSelectionStep /> },
            { name: "Negociar", component: <NegotiationStep /> },
            { name: "Posicionar", component: <SpotTreeSelectionStep /> },
            { name: "Resumen", component: <SummaryStep /> }
        ];
        return (
            <div>
                <ContractTypeModal
                    show={this.state.showContractModal}
                    onHide={() => this.setState({ showContractModal: false, loading: false })}
                />
                {
                    this.state.loading == true ?
                        <Loader show={true} classes={"map-default-height"} />
                        :
                        <StepZilla
                            showNavigation={false}
                            steps={steps}
                            dontValidate={false}
                            stepsNavigation={false}
                            preventEnterSubmission={true}
                            nextButtonText="Siguiente"
                            backButtonText="Atrás"
                            nextButtonCls='btn btn-prev btn-md float-right bg-light-secondary'
                            backButtonCls='btn btn-next btn-md float-left bg-light-secondary'
                            hocValidationAppliedTo={[0, 1, 2]}
                            nextTextOnFinalActionStep="Guardar"
                            prevBtnOnLastStep={false}
                            onStepChange={(step) => this.handleStepChange(step)}
                        />
                }
            </div>
        )
    }
}
export default connect(
    null,
    { cleanSaleOrder, fetchContractTypeSeller },
    null,
    { withRef: true }
)(SalesWizard);



// WEBPACK FOOTER //
// ./src/components/SalesWizard/SalesWizard.jsx